import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FadeInOut from 'base/react/animations/fade_in_out'
import Button from '@everlane/button'
import LoadingAnimation from 'base/react/components/loading_animation'
import Input from 'base/react/components/form/input'
import EyeActive from 'base/components/ui/eye-active'
import EyeInactive from 'base/components/ui/eye-inactive'
import store from 'base/store'

class SignInForm extends Component {
  static propTypes = {
    initialEmail: PropTypes.string,
    onSubmit: PropTypes.func,
    errors: PropTypes.object,
    ctaText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  static defaultProps = {
    ctaText: 'Log In',
    onSubmit: () => {},
  }

  state = {
    passwordRevealed: false,
    formValues: {
      email: this.props.initialEmail || '',
      password: '',
    },
  }

  widgetId = null

  componentDidMount() {
    this.widgetId = window.turnstile.render('.cf-turnstile')
  }

  componentWillUnmount() {
    window.turnstile.remove(this.widgetId)
  }

  renderTurnstileWidget() {
    const siteKey = store.getState().appConfig.turnstileSiteKey

    return <div className="cf-turnstile" data-sitekey={siteKey} data-theme="light" />
  }

  handleSubmit = event => {
    event.preventDefault()
    const turnstile_code = window.turnstile.getResponse()
    this.props.onSubmit({ ...this.state.formValues, turnstile_code })
  }

  renderPasswordRevealIcon() {
    const togglePassword = () => this.setState({ passwordRevealed: !this.state.passwordRevealed })

    return (
      <div onClick={togglePassword} className="login__password-reveal">
        {this.state.passwordRevealed ? <EyeActive /> : <EyeInactive />}
      </div>
    )
  }

  renderEmailFieldset() {
    const onChange = event => {
      this.setState({
        formValues: {
          ...this.state.formValues,
          email: event.currentTarget.value,
        },
      })
    }

    return (
      <Input
        inputClass="login__input"
        wrapperClass="login__email-container"
        error={this.props.errors ? this.props.errors.email : null}
        id="email"
        name="email"
        onChange={onChange}
        placeholder="Email Address"
        required="true"
        type="email"
        value={this.state.formValues.email}
        autocomplete="username email"
      />
    )
  }

  renderPasswordFieldset() {
    const onChange = event => {
      this.setState({
        formValues: {
          ...this.state.formValues,
          password: event.currentTarget.value,
        },
      })
    }

    return (
      <div className="login__password-container">
        <Input
          inputClass="login__input"
          error={this.props.errors ? this.props.errors.password : null}
          id="password"
          name="password"
          onChange={onChange}
          placeholder="Password"
          required="true"
          type={this.state.passwordRevealed ? 'text' : 'password'}
          value={this.state.formValues.password}
          autocomplete="current-password"
        />
        {this.renderPasswordRevealIcon()}
      </div>
    )
  }

  render() {
    const button = (() => {
      if (this.props.isLoading) {
        return (
          <div className="login__loading-animation-container">
            <LoadingAnimation />
          </div>
        )
      }

      return (
        <Button
          className="flat-button--full-width login__button"
          type="submit"
          onClick={this.handleSubmit}
          variant="rectangle"
          dark
        >
          {this.props.ctaText}
        </Button>
      )
    })()

    return (
      <FadeInOut>
        <form className="login__sign-in" onSubmit={this.handleSubmit}>
          {this.renderEmailFieldset()}
          {this.renderPasswordFieldset()}
          {this.renderTurnstileWidget()}
          {button}
        </form>
      </FadeInOut>
    )
  }
}

export default SignInForm
